import { Suspense } from 'react';
import AppLoader from './loader/app-loader';

// LOADABLE - LAZY LOADING

const Loadable = (Component) => (props) => (
  <Suspense fallback={<AppLoader />}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
